// extracted by mini-css-extract-plugin
export var layoutContainer = "_dw-0";
export var layoutContainerNoRounding = "_dw-6";
export var layoutContainerOpen = "_dw-5";
export var layoutContainerResizing = "_dw-1";
export var mainContent = "_dw-2";
export var resizeDivider = "_dw-3";
export var slidePanel = "_dw-4";